// removed by extract-text-webpack-plugin
module.exports = {"header":"h2_bg _1AvxiCsDEMdGie2oWv5Qv_","title":"h2_n","tagline":"h2_h3","button":"h2_bp"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Discovery/components/SearchHeader/styles.module.css
// module id = 1254
// module chunks = 27